import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import APIKit from "../../Middleware/axiosConfig";

// API End Points
import { API_END_POINTS } from "../../Middleware/apiEndpoints";

//utils
import { notifyError } from "Services/Utils/toastNotification";


// API calls

export const fetchProductCatalogCategory = createAsyncThunk("fetchProductCatalogCategory", async ({data, callBack}) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.productCategory}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.productCategory} ====> ${JSON.stringify(
        response?.message
      )}`
    );
  }
  return response?.data;
});
export const fetchProductCatalogType = createAsyncThunk("fetchProductCatalogType", async ({data, callBack}) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.productFiltrationTypes}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.productFiltrationTypes} ====> ${JSON.stringify(
        response?.message
      )}`
    );
  }
  return response?.data;
});
export const fetchProductCatalogSubCategory = createAsyncThunk("fetchProductCatalogSubCategory", async ({data, callBack}) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.productSubCategory}/${data}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.productSubCategory} ====> ${JSON.stringify(
        response?.message
      )}`
    );
  }
  return response?.data;
});
export const fetchProductsList = createAsyncThunk("fetchProductsList", async ({data, callBack}) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.productList}?search=${data.search}&page=${data.page}&limit=${data.limit}&sort_by=${data.sort_by}&order_by=${data.order_by}`);
  if (response?.status === 200 || (response?.status === 400 && response?.data?.message === "No data found!")) {
    callBack(response?.data);
  } else {
    // alert(response?.message);
    console.log(
      `Error ===> ${API_END_POINTS.productList} ====> ${JSON.stringify(
        response?.message
      )}`
    );
  }
  return response?.data;
});

export const fetchIndividualProduct = createAsyncThunk("fetchIndividualProduct", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.individualProduct}?product_catalog_id=${data.id}&${data.category_id ? `category=${data.category_id}` : ""}${data.filter_id ? `&filterType=${data.filter_id}` : ""}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.individualProduct} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const deleteProduct = createAsyncThunk("deleteProduct", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().delete(`${API_END_POINTS.deleteProduct}/${data.id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.deleteProduct} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const updateProductStatus = createAsyncThunk("updateProductStatus", async ({data,callBack}) => {
  // api hit
  console.log(data)
  const response = await APIKit().put(`${API_END_POINTS.productStatusChange}/${data.status}/${data.id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.productStatusChange} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const addProduct = createAsyncThunk("addProduct", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().post(`${API_END_POINTS.addProduct}`,data);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.addProduct} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const editProduct = createAsyncThunk("editProduct", async ({data,callBack,id}) => {
  // api hit
  const response = await APIKit().put(`${API_END_POINTS.editProduct}/${id}`,data);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.editProduct} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});


 export const productCatalogSlice = createSlice({
  name: "productCatalog",
  initialState: { isLoading: false },
  reducers: {},
  extraReducers: (builder) => {

    builder
      .addCase(fetchProductCatalogCategory.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchProductCatalogCategory.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchProductCatalogCategory.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchProductCatalogType.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchProductCatalogType.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchProductCatalogType.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchProductCatalogSubCategory.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchProductCatalogSubCategory.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchProductCatalogSubCategory.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchProductsList.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchProductsList.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchProductsList.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchIndividualProduct.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchIndividualProduct.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchIndividualProduct.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(deleteProduct.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(deleteProduct.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(deleteProduct.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(updateProductStatus.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(updateProductStatus.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(updateProductStatus.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(addProduct.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(addProduct.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(addProduct.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(editProduct.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(editProduct.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(editProduct.rejected, (state, action) => {
        state.isLoading = "failed";
      });

  },
});

export default productCatalogSlice.reducer;
